/* globals Modernizr */
require('../styles/main.scss');
require('script-loader');
require('script-loader!./modernizr');

exports.init = function() {

  if(!(Modernizr.classlist && Modernizr.placeholder)) {
    // TODO: Should probably just code a workaround for browsers that don't 
    // support these features. 
    // js features not supported, display original form 
    return;
  }

  appendOverlay();

  // must wait for document to fully load to parse form
  window.onload = function() {

    // Visa checkout / masterpass seem to trigger a second onload event, so 
    // we need to check if we've already rendered the new form
    if(!document.querySelector('.new-form')) {
      
      enableConsoleErrors();
      overwriteDisableControlFunction();
      const oldForm = document.querySelector('form#frmPayment');
      const formData = parseForm(oldForm);
      addNewPageContent(oldForm, formData); 
      toggleShippingFieldset();

      showForm(); // Should always be the final call
    }
  };
};

// Overlay to avoid flashing the old form while the new form is generated. 
// Styled inline to avoid a Flash-Of-Unstyled-Content (FOUC).
function appendOverlay() {
  var overlay = document.createElement('div');
  overlay.id = 'overlay';
  document.body.appendChild(overlay);

  // Inlined style, also in the stylesheet
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'white';
  overlay.style.zIndex = '100';
  overlay.zIndex = '1000';
  overlay.opacity = '1';

  document.body.classList.add('no-scroll');
  appendSpinner();
}

// Bambora UI spinner while new form is being generated. 
function appendSpinner() {
  const spinner = document.createElement('div');
  const spinner_left = document.createElement('div');
  const spinner_right = document.createElement('div');
  
  spinner.classList.add('spinner');
  spinner_left.classList.add('spinner-left');
  spinner_right.classList.add('spinner-right');

  // Inlined styles to avoid FOUC (also exist in stylesheet)
  spinner.style.position = 'fixed';
  spinner.style.top = '50%';
  spinner.style.left = '50%';
  spinner.style.marginLeft = '-25px';
  spinner.style.marginTop = '-25px';  

  spinner.appendChild(spinner_left);
  spinner.appendChild(spinner_right);
  document.body.appendChild(spinner);
}

// The legacy Javascript on the Hosted Payment Page has a method to disable 
// all javascript error output. This method unsets that. 
function enableConsoleErrors() {
  window.onerror = function() { return false; };
}

// The legacy Javascript on the Hosted Payment Page has a method DisableControl()
// that breaks if more than one css file is linked to the page. This method 
// overwrites that function on the original page, while preserving the necessary
// functionality. 
function overwriteDisableControlFunction() {
  var str = `function DisableControl(objName, dControl) {    
            if (objName) { //perform disable if obj exists
              if (dControl == true) {
                objName.disabled = true;
              } else {
                objName.disabled = false;
              }
            }
          }`;

  var script = document.createElement('script');
  script.innerHTML = str;
  document.body.appendChild(script);
}

// Parse the old form into an object that be easily passed around. 
function parseForm(form) {
  const formData = {};
  formData.digitalWallets = getDigitalWallets(form);
  formData.inputs = getInputs(form);
  formData.headers = getHeaders(form);
  formData.cards = getCards(form);
  return formData;
}

// Add the new form and surrounding content to the page
function addNewPageContent(oldForm, data) {
  var testModeString = getTestModeString();

  const language = getUrlParameter('trnLanguage') || 'eng';

  var checkoutDiv = document.createElement('div'); 
  checkoutDiv.id = 'checkout';

  var checkoutContainerDiv = document.createElement('div');
  checkoutContainerDiv.id = 'checkout-container'; 

  checkoutDiv.appendChild(checkoutContainerDiv); 
  oldForm.parentNode.insertBefore(checkoutDiv, oldForm); 

  const newForm = createForm(data, checkoutContainerDiv);
  updateFormContent(newForm);
  renameFormAndRemoveOld(newForm, oldForm);

  appendCreditCardInfo(data.cards, checkoutContainerDiv, language); 
  appendBrandingTagline(checkoutContainerDiv, language);
  
  prependErrorBlock(checkoutContainerDiv);
  prependTestModeString(checkoutContainerDiv, testModeString);
  
  highlightErrorFields(newForm);
  appendFocusFunction(newForm);
}

// Preprend the 'test-mode string' to a div
function prependTestModeString(div, str) {
  if(str) {
    var p = document.createElement('p');
    p.id = 'test-mode';
    p.innerHTML = str;
    div.insertBefore(p, div.childNodes[0]);
  }
}

// Returns the test mode string if the form is in test mode, or else returns 
// false
function getTestModeString() {
  var testModeString = document.querySelector('font[color="red"] > b');
  if(testModeString) {
    return testModeString.innerHTML;
  }
  return false;
}

// Get and parse Visa Checkout / Masterpass if they are present on the form
function getDigitalWallets(form) {
  var wallets = {};

  // Check for visa checkout 
  var visaCheckoutDiv = form.querySelector('#divVCButton');
  if (visaCheckoutDiv) {
    wallets['visaCheckout'] = {
      text: visaCheckoutDiv.parentElement.querySelector('div > a').parentElement, 
      image: form.querySelector('#divVCButton > img'),
    };
  }

  // check for masterpass 
  var masterpassImage = form.querySelector(
    'img[src^="https://www.mastercard.com"]');
  if (masterpassImage) {
    wallets['masterpass'] = {
      text: masterpassImage.parentElement.querySelector('a'),
      image: masterpassImage,
    };
  }

  return wallets;
}

// Get and parse the inputs, textareas, and selects from the old form. 
function getInputs(form) {
  var inputs = {};
  const inputElements = form.querySelectorAll('input[type=text], input[type=button], \
    input[type=checkbox], input[type=radio], input[type=hidden], textarea, select');
  
  Array.prototype.forEach.call(inputElements, input => {
    if (input.type === 'radio') {
      inputs[input.id] = {
        text: getLabelText(input), 
        element: input,
      };
    } else {
      inputs[input.name] = {
        text: getLabelText(input), 
        element: input,
      };
    } 
  });

  return inputs;
}

// Get the associated label text for an input from the old form. 
function getLabelText(input) {

  var labelText = '';

  if((input.tagName === 'INPUT' && input.type === 'text')  || 
      (input.tagName === 'SELECT')) {
    labelText = input.parentElement.parentElement.querySelector('font');

    if(labelText) {
      if(labelText.querySelector('span')) {
        labelText = labelText.querySelector('span');
      }

      // Error fields come back in <font> tags
      if(labelText.querySelector('font')) {
        labelText = labelText.querySelector('font');
      }

      labelText = labelText.innerHTML;
    }
  
  } else if(input.tagName === 'INPUT' && input.type === 'checkbox') {
    labelText = input.parentElement.querySelector('font');
    labelText = labelText.innerHTML;
  } else if(input.type === 'radio') {
    labelText = input.parentElement.querySelector('label[for='+ input.id + ']');
    labelText = labelText.innerText;
  }

  return labelText;
}

// Get the header titles and associate with their formgroup from the old form. 
function getHeaders(form) {
  var headers = {};
  const headerTags = form.querySelectorAll('font[size="3"] b');
  
  Array.prototype.forEach.call(headerTags, header => {
    const headerText = header.innerHTML;

    // get headerRow 
    var parent = header.parentElement;
    while(parent.tagName !== 'TR') {
      parent = parent.parentElement;
    }
    const headerRow = parent;

    // get first input row 
    var sibling = headerRow.nextSibling;
    while(sibling.tagName !== 'TR') {
      sibling = sibling.nextSibling;
    }
    const inputRow = sibling;

    if(inputRow.querySelector('input[name^=ord]')) {
      headers['billing'] = headerText;
    } else if(inputRow.querySelector('input[name^=ship]')) {
      headers['shipping'] = headerText;
    } else if(inputRow.querySelector('img')) {
      headers['payment'] = headerText;
    } else if(inputRow.querySelector('textarea[name^=trn]')) {
      headers['comments'] = headerText;
    }
  });

  // Add a header for digital wallets if present 
  if (form.querySelector('#divVCButton') || 
    form.querySelector('img[src^="https://www.mastercard.com/"]')) {
    headers['digitalWallets'] = '';
  }

  // Add hidden header for submit, cancel buttons fieldset
  headers['buttons'] = '';

  return headers;
}


// Get the accepted cards of the old form, based on the card images present. 
function getCards(form) {
  const images = form.getElementsByTagName('img');
  var cards = [];
  Array.prototype.forEach.call(images, img => { 
    const filename = img.src.split('/').pop();
    switch(filename) {
      case '10_VI_cardLogo.png':
        cards.push('Visa');
        break;
      case '20_PV_cardLogo.png': 
        cards.push('Visa');
        break;
      case '30_MC_cardLogo.png':
        cards.push('Mastercard');
        break;
      case '35_MD_cardLogo.png':
        cards.push('Mastercard');
        break;
      case '40_NN_cardLogo.jpg':
        cards.push('Discover');
        break;
      case '50_AM_cardLogo.png':
        cards.push('Amex');
        break;
      case '60_IO_cardLogo.png':
        cards.push('INTERAC Online');
        break;
      default: 
    }
  });
  return cards;
}

// Create the new form (and surrounding html tags), and add the parsed fields 
// and buttons from the old form. 
function createForm(data, div) {

  var form = document.createElement('form');
  form.id = 'paymentForm';
  form.classList.add('hidden');
  form.style.display = 'none';
  form.style.opacity = 0;

  appendFields(form, data); 
  div.appendChild(form);
  return form;
}

// General catchall method for a bunch of updates to the form's content.
function updateFormContent(form) {

  // Change default option text for province select (ord)
  // Was 'Select your state/province' -- incosistent with rest of form
  var ordProvinceSelect = form.querySelector('select[name="ordProvince"]');
  if(ordProvinceSelect && ordProvinceSelect.disabled == false) {
    var ordProvinceDefault = ordProvinceSelect.querySelector(
      'option[disabled]');
    ordProvinceDefault.innerHTML = 'Region'; 
  }

  // Change default option text for province select (ship)
  // Was 'Select your state/province' -- incosistent with rest of form
  var shipProvinceSelect = form.querySelector('select[name="shipProvince"]');
  if(shipProvinceSelect && shipProvinceSelect.disabled == false) {
    var shipProvinceDefault = shipProvinceSelect.querySelector(
      'option[disabled]');
    shipProvinceDefault.innerHTML = 'Region';
  }

  // Add button classes to the submit and cancel buttons 
  var submit = form.querySelector('input[name="submitButton"]'); 
  if(submit) {
    submit.classList.add('btn');
    submit.classList.add('btn-large');
  }
  var cancel = form.querySelector('input[name="cancelButton"]');
  if(cancel) {
    cancel.classList.add('btn');
    cancel.classList.add('btn-large');
    cancel.classList.add('btn-secondary');
  }

  // Add extra onclick to 'shipSameAsOrd' checkbox so the entire shipping 
  // fieldset can be hidden (along with the disabled fields)
  var checkbox = form.querySelector('input[name="shipSameAsOrd"]');
  if(checkbox) {
    checkbox.addEventListener('change', toggleShippingFieldset);
  }


  // Update the country selects on change to only display the state/province 
  // <select> when country is US or Canada.
  var billingCountrySelect = form.querySelector('select[name="ordCountry"]');
  var shippingCountrySelect = form.querySelector('select[name="shipCountry"]');

  // Event listener function: 
  var onCountryChange = function(event) {
    var provinceSelector, provinceSelect, countrySelect;
    countrySelect = event.srcElement; 
    if (event.srcElement.name === 'ordCountry') {
      provinceSelector = '[name="ordProvince"]';
    } else {
      provinceSelector = '[name="shipProvince"]';
    }

    provinceSelect = form.querySelector(provinceSelector);
    if (event.srcElement.value === 'CA' || event.srcElement.value === 'US') {
      provinceSelect.style.display = 'block';
      countrySelect.style.width = '100%';
    } else {
      provinceSelect.style.display = 'none';
      countrySelect.style.width = 'calc(100% + 1px)'; 
    }
  };

  // add event listener to country selects
  if(billingCountrySelect && billingCountrySelect.disabled == false) {
    billingCountrySelect.addEventListener('change', onCountryChange);
  }
  if(shippingCountrySelect && shippingCountrySelect.disabled == false) {
    shippingCountrySelect.addEventListener('change', onCountryChange);
  }

  // trigger the change event immediately for initial display
  if ('createEvent' in document) {
    var evt = document.createEvent('HTMLEvents');
    evt.initEvent('change', false, true);
    if (billingCountrySelect) {
      billingCountrySelect.dispatchEvent(evt);
    }
    if (shippingCountrySelect) {
      shippingCountrySelect.dispatchEvent(evt);
    }
  } else {
    if (billingCountrySelect) {
      billingCountrySelect.fireEvent('onchange');
    }
    if (shippingCountrySelect) {
      shippingCountrySelect.fireEvent('onchange');
    }
  }


  // Don't hide CVD field when it's disabled by card validation. 
  // For some reason CVD is disabled by the current form when the card validation
  // fails, not sure why but seems pretty intentional. Normally fields are hidden
  // when disabled on the new form, but in this case need to keep displaying it.
  var paymentMethodSelect = form.querySelector('[name="paymentMethod"]');
  if (paymentMethodSelect) {
    paymentMethodSelect.addEventListener('change', function() {

      var cardDisabled = false;
      if (this.value === 'IO' || this.value === 'EW') {
        cardDisabled = true;
      }

      var cardCvd = form.querySelector('[name="trnCardCvd"]'); 

      if(cardDisabled && cardCvd) {
        cardCvd.classList.add('hide-cvd');
      } else if (cardCvd) {
        cardCvd.classList.remove('hide-cvd'); 
      }
    });
  }

  // Prevent the textarea's height and width from being affected by form 
  // settings 
  var textarea = document.querySelector('textarea');
  if (textarea) {
    textarea.rows = 4;
    textarea.cols = 40;
  }
}

function toggleShippingFieldset() {
  var checkbox = document.querySelector('input[name="shipSameAsOrd"]');
  var shippingFieldset = document.querySelector('#shipping-fieldset');
  if(checkbox && shippingFieldset) {
    if (checkbox.checked) {
      shippingFieldset.classList.add('hidden');
    } else {
      shippingFieldset.classList.remove('hidden');
    }
  }
}

// Remove the overlay and spinner and show the form and (if present) validation 
// errors.
function showForm() {
  var spinner = document.querySelector('.spinner');
  var overlay = document.querySelector('#overlay');
  var form = document.querySelector('form#frmPayment');
  var errors = document.querySelector('#errors');

  overlay.style = null;
  spinner.style = null;
  overlay.classList.add('fade-out');
  spinner.classList.add('fade-out');

  setTimeout(() => { // Remove overlay/spinner after fade out
    document.body.removeChild(spinner);
    document.body.removeChild(overlay);
  }, 500);

  document.body.classList.remove('no-scroll');
  
  form.classList.remove('hidden');
  form.style.opacity = null;
  form.style.display = 'block';
  
  if(errors) errors.style.display = 'block';
}

// Add all the inputs that have been parsed from the old form to the new form 
function appendFields(form, data) {

  const formLayout = getNewFormLayout();
  const fieldsetNames = Object.keys(formLayout); // e.g. hidden, payment, ...

  // Create the fieldsets and titles
  var fieldsets = {};
  fieldsetNames.forEach(name => {
    fieldsets[name] = document.createElement('fieldset');
    fieldsets[name].classList.add('form-group');
    fieldsets[name].id = `${name}-fieldset`;

    // Special case VisaCheckout and Masterpass fieldset
    // TODO: Clean up, seperate this code
    if (name === 'digitalWallets') {
      var walletLegend = document.createElement('legend');
      walletLegend.appendChild(document.createTextNode(data.headers[name]));
      fieldsets[name].appendChild(walletLegend); 
      
      if (isEmpty(data.digitalWallets)) {
        fieldsets[name].style.display = 'none';
      }  
      return;
    }

    // Hide this fieldset if it's not visible on the original form
    if(Object.keys(data.headers).indexOf(name) == -1) {
      fieldsets[name].style.display = 'none';
      data.headers[name] = name;
    }

    if(data.headers[name]) {
      var legend = document.createElement('legend'); 
      legend.appendChild(document.createTextNode(data.headers[name])); 
      fieldsets[name].appendChild(legend);
    }
  });

  // Add fields to the fieldsets based on the defined layout
  fieldsetNames.forEach(fieldsetName => {
    var fieldsetLayout = formLayout[fieldsetName]; 
    fieldsetLayout.forEach(layoutRow => {

      var row = document.createElement('div');
      row.classList.add('row');

      // Empty layout rows will put a space between fields
      if(layoutRow.length === 0) {  
        row.classList.add('spacer');
      } else {

        layoutRow.forEach(fieldName => {

          // Handle digital wallet case 
          // TODO: As above, this is messy the way its included right now, 
          // should refactor this arrow function, maybe seperate into methods
          if (fieldsetName === 'digitalWallets') {
            if (!isEmpty(data.digitalWallets)) {
              var wallet = data.digitalWallets[fieldName];
              if(wallet) {
                moveDigitalWallet(fieldName, wallet, row);
              }
              return;
            }
          }

          // Otherwise, 
          var field = data.inputs[fieldName];

          if(field) {
            moveElement(field, row);

          } else if(fieldName === 'trnAmount') {
            // else if the amount field has been disabled, we still 
            // need to display the amount.
            var disabledAmountField = createDisabledAmountField();
            moveElement(disabledAmountField, row);
          
          } else if(fieldName === 'trnOrderNumber') {
            // if a fixed order number is displayed on the original form,
            // need to display it here.
            var disabledOrderNumField = createDisabledOrderNumField();
            if (disabledOrderNumField) {
              moveElement(disabledOrderNumField, row);
            }
          }
        });
      }

      fieldsets[fieldsetName].appendChild(row);

    });
  });

  Object.keys(fieldsets).forEach(fs => form.appendChild(fieldsets[fs]));  
}

// Create the field to append to the form if the amount is not an editable 
// field. In this case there's no input element to copy over from the old form. 
function createDisabledAmountField() {
  var disabledInput = document.createElement('input');
  disabledInput.type = 'text';
  disabledInput.name = 'disabledAmount';
  disabledInput.disabled = true;
  disabledInput.id = 'disabledAmount';
  
  disabledInput.value = getDisabledAmountValue();

  return {element: disabledInput, text: 'Amount'};
}

// If an order num is displayed on the old form, create an element for it 
function createDisabledOrderNumField() {

  var orderNumber = getDisabledOrderNumber();

  var disabledInput = document.createElement('input');
  disabledInput.type = 'text';
  disabledInput.name = 'disabledOrderNum';
  disabledInput.disabled = true;
  disabledInput.id = 'disabledOrderNum';
  disabledInput.value = orderNumber;

  if(orderNumber) {
    return {element: disabledInput, text: 'Order Number'};
  }
  return false;
}

// Get the amount value from the page if the field is not editable. 
// TODO: This function is kind of messy / brittle right now. Could be improved.
function getDisabledAmountValue() {
  var possibleTags = document.querySelectorAll('td + td > font'); 
  var res = null;
  Array.prototype.forEach.call(possibleTags, tag => {
    if(tag.innerHTML.indexOf('$') !== -1) {
      var str = tag.innerHTML;
      res = str.replace(/&nbsp;/gi, ' ');
    }
  });
  return res;
}

function getDisabledOrderNumber() {
  var orderNumLabel = null; 
  var orderNum = null;

  var labels = document.querySelectorAll(
    'tr > td > font[face="Arial"][size="2"][color="000000"]');
  Array.prototype.forEach.call(labels, label => {
    if(label.innerHTML == 'Invoice/Order Number:' || 
       label.innerHTML.indexOf('commande') !== -1) {
      orderNumLabel = label; 
    }
  });

  if(orderNumLabel) {
    orderNum = orderNumLabel.parentElement.nextSibling.nextSibling.querySelector(
      'font').innerHTML;
  } 

  return orderNum;
}

// Defines the layout for the new form. Fields are grouped by fieldgroup 
// (object keys), each list in a fieldgroup is a row. An empty row will put
// a vertical space between rows. Change the object to change the form layout. 
function getNewFormLayout() {
  return {
    hidden: [
      // TODO: Should just move over all hidden fields instead of needing to 
      // specify them here. 
      ['sessionToken'], 
      ['paymentAction'],
      ['merchant_id'],
      ['preview'],
      ['masterPassReturn'],
      ['oauth_verifier'],
      ['oauth_token'],
      ['checkout_resource_url'],
      ['visaCheckoutCallId'],
      ['visaCheckoutReturn'],
      ['aDFinancingType'],
      ['aDPlanNumber'],
      ['aDGracePeriod'], 
      ['aDTerm'], 
      ['gpTrnString'],
      ['threeDSServerTransID'],
    ],

    digitalWallets: [
      ['visaCheckout', 'masterpass'],
    ],

    payment: [
      ['trnAmount', 'trnOrderNumber'], 
      [], // Spacing between rows 
      ['paymentMethod'], 
      ['trnCardType'], 
      ['trnCardOwner'], 
      ['trnCardNumber'], 
      ['trnExpMonth', 'trnExpYear', 'trnCardCvd'],
    ], 

    billing: [
      ['ordName'],
      ['ordEmailAddress'],
      ['ordPhoneCountryCode', 'ordPhoneNumber'],
      ['mobile', 'home', 'work'],
      ['ordAddress1', 'ordAddress2'], 
      ['ordCity', 'ordPostalCode'], 
      ['ordProvince', 'ordCountry'],
      ['shippingRequired'], 
      ['shipSameAsOrd'],
    ],

    shipping: [
      ['shipName'],
      ['shipEmailAddress'],
      ['shipPhoneCountryCode','shipPhoneNumber'],
      ['shipAddress1', 'shipAddress2'], 
      ['shipCity', 'shipPostalCode'],
      ['shipProvince', 'shipCountry'],
    ],

    comments: [
      ['trnComments'],
    ],

    buttons: [
      ['submitButton'],
      ['cancelButton'],
    ],
  };
}

function moveDigitalWallet(name, data, row) {
  var walletDiv = document.createElement('div');
  walletDiv.classList.add('digital-wallet');

  var p;
  if (name === 'visaCheckout') {
    data.text.style = null;
    walletDiv.appendChild(data.image);
    p = document.createElement('p');
    p.appendChild(data.text.querySelector('a'));
    p.id = 'visa-checkout-text';
    walletDiv.appendChild(p);

  } else if (name === 'masterpass') {

    data.text.innerHTML = 'Learn More';
    data.image.src = 'https://static.masterpass.com/dyn/img/btn/global/mp_chk_btn_147x034px.svg';
    walletDiv.appendChild(data.image);
    p = document.createElement('p');
    p.id = 'masterpass-text';
    p.appendChild(data.text);
    walletDiv.appendChild(p);
  }

  row.appendChild(walletDiv);
  return;
}

function moveElement(fieldData, row) {
  var element = fieldData.element;
  element.removeAttribute('style');

  if('placeholder' in element) {
    var placeholder = fieldData.text || ''; 
    element.placeholder = makeSentenceCase(placeholder.replace(':', ''));
  }

  if ('autocomplete' in element) {
    element.autocomplete = false;
  }

  // create label (hidden if not checkbox)
  var label = document.createElement('label');
  if(!element.id) element.id = element.name;
  label.htmlFor = element.id;
  var labelText = fieldData.text;
  label.appendChild(document.createTextNode(makeSentenceCase(labelText)));

  if(element.tagName === 'INPUT' && element.type === 'checkbox') {
    var checkboxDiv = document.createElement('div');
    checkboxDiv.classList.add('checkbox');

    checkboxDiv.appendChild(element);
    checkboxDiv.appendChild(label);
    row.appendChild(checkboxDiv);
  } else if (element.tagName === 'INPUT' && element.type === 'radio') {
    var radioDiv = document.createElement('div');
    radioDiv.classList.add('radio');

    radioDiv.appendChild(element);
    radioDiv.appendChild(label);
    row.appendChild(radioDiv);
  } else if (label.innerText === '' && label.textContent === '') {

    row.appendChild(element);
  } else {

    row.appendChild(label);
    label.classList.add('sr-only');
    row.appendChild(element); 
  }
}

function makeSentenceCase(str) {
  if(!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function renameFormAndRemoveOld(newForm, oldForm) {
  newForm.action = oldForm.action; 
  newForm.method = oldForm.method;
  var id = oldForm.id; 
  oldForm.parentNode.removeChild(oldForm);
  newForm.id = id;
  newForm.classList.add('new-form');

  // Move js script outside of old form
  var legacyJs = document.querySelectorAll('table script');
  Array.prototype.forEach.call(legacyJs, script => { 
    document.body.appendChild(script);
  });

  // Remove other page content
  var oldTestModeString = document.querySelector(
    'font[face="Arial"][color="red"][size="2"] > b');
  if(oldTestModeString && oldTestModeString.innerHTML.indexOf('test') !== -1) {
    oldTestModeString.parentNode.parentNode.removeChild(oldTestModeString.parentNode);
  }

  // Remove <br> that gets added to top of form 
  var br = document.querySelector('br');
  if(br) {
    br.parentNode.removeChild(br);
  }

  // Remove 'Please complete all highlighted fields error' if present
  var tables = document.querySelectorAll('table');
  Array.prototype.forEach.call(tables, table => {
    var b = table.querySelector('b');

    if (b && (b.innerHTML === 'Please complete all highlighted fields:' ||
      b.innerHTML.includes('Veuillez remplir les champs'))) {
      table.parentElement.removeChild(table);
    }
  });
   
  // Move script pararaph to bottom of page 
  var scriptP = document.querySelector('p > script'); 
  if(scriptP) {
    document.body.appendChild(scriptP.parentNode);
  }
}

function appendCreditCardInfo(cards, element, language) {

  if(cards.length == 0) { return; }

  if (language === 'fre') {
    cards = cards.map( card => {
      if (card === 'INTERAC Online') {
        return 'INTERAC En Ligne';
      } 
      return card;
    });
  }

  var small = document.createElement('small');
  var text = ''; 

  cards = cards.map(card => '<strong>' + card + '</strong>');

  if(cards.length == 1) {
    if (language === 'fre') {
      text = `${cards[0]} est acceptée.`;
    } else {
      text = `${cards[0]} is accepted.`; 
    }
  } else if (cards.length == 2) {
    if (language === 'fre') {
      text = `${cards[0]} et ${cards[1]} sont acceptées.`;
    } else {
      text = `${cards[0]} and ${cards[1]} are accepted.`; 
    }
  } else {
    if (language === 'fre') {
      text = `${cards.slice(0, cards.length-1).join(', ')} et ${cards[cards.length-1]} sont acceptées.`;
    } else {
      text = `${cards.slice(0, cards.length-1).join(', ')} and ${cards[cards.length-1]} are accepted.`;
    }
  }

  small.innerHTML = text; 
  element.appendChild(small);
}

function appendBrandingTagline(element, language) {
  var img = document.createElement('img'); 
  if (language === 'fre') {
    img.src = 'https://cdn.na.bambora.com/resources/brand/realise_par_badge_grey200x22.png';
  } else {
    img.src = 'https://cdn.na.bambora.com/resources/brand/powered_by_badge_grey200x23.png';
  }
  img.alt = 'Powered by Bambora';
  img.id = 'powered-by-img';
  element.appendChild(img);
}

function prependErrorBlock(element) {
  var errorMessage = getUrlParameter('errorMessage');
  
  if(errorMessage) {

    var errorDiv = document.createElement('div');
    errorDiv.id = 'errors';
    errorDiv.style.display = 'none';

    errorMessage = errorMessage.split('+').join(' ');
    var errorList = document.createElement('ul');
    errorList.innerHTML = errorMessage;
    errorDiv.appendChild(errorList);

    var iconDiv = document.createElement('div');
    iconDiv.id = 'icon';
    var icon = '<svg width="30" height="26" viewBox="0 0 30 26" xmlns="http://www.w3.org/2000/svg"><title>2FD1CD11-7ADB-47DB-B000-9067DDD311EF</title><g transform="translate(.84 .48)" fill="none" fill-rule="evenodd"><path d="M21.63 5.201H2.434A2.427 2.427 0 0 0 0 7.621v11.13c0 1.337 1.09 2.42 2.434 2.42h3.36l-1.057 4.406 5.964-4.406h10.93a2.427 2.427 0 0 0 2.433-2.42V7.621c0-1.336-1.09-2.42-2.434-2.42" fill="#25A998"></path><ellipse fill="#E05043" cx="23.354" cy="5.201" rx="5.19" ry="5.201"></ellipse><rect fill="#FFF" x="22.983" y="2.229" width="1.112" height="4.087" rx="50"></rect><rect fill="#FFF" x="22.983" y="7.059" width="1.112" height="1.115" rx="50"></rect></g></svg>';
    iconDiv.innerHTML = icon;
    errorDiv.insertBefore(iconDiv, errorDiv.childNodes[0]);
    element.insertBefore(errorDiv, element.childNodes[0]);
  }
}

function highlightErrorFields(form) {
  var errorFields = getUrlParameter('errorFields'); 
  if(errorFields) {
    var fields = form.querySelectorAll('input');
    Array.prototype.forEach.call(fields, field => field.classList.remove('invalid'));
    errorFields = errorFields.split(',');
    Array.prototype.forEach.call(errorFields, fieldName => {
      var field = form.querySelector(`[name='${fieldName}']`);
      if(field) {
        field.classList.add('invalid');
      } else {
        console.log(`Error: Cannot find field ${fieldName}`);
      }
    });
  }
}

function appendFocusFunction(form) {
  var inputs = form.querySelectorAll('input');
  Array.prototype.forEach.call(inputs, input => input.onfocus = function() {
    var selected = document.querySelectorAll('.selected');
    Array.prototype.forEach.call(selected, element =>  {
      element.classList.remove('selected');
    });
    input.classList.add('selected');
  });

  Array.prototype.forEach.call(inputs, input => input.onblur = function() {
    input.classList.remove('selected');
  });
}

//http://stackoverflow.com/questions/19491336/\
//get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
}

function isEmpty(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop))
      return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./app/js/main.js